import React, { useState, Fragment, Component } from 'react';
import { ChevronDown, ChevronRight, Award, Building, AlertTriangle, Package, DollarSign } from 'lucide-react';
export function BOMDetailsCard() {
  const [expandedIngredient, setExpandedIngredient] = useState<string | null>(null);
  const ingredients = [{
    ingredient: 'Vitamin D3 (Cholecalciferol)',
    quantityPerServing: '1000 IU',
    costPerUnit: '$0.045',
    extendedCost: '$1.35',
    supplier: 'DSM Nutritional',
    dailyValue: '250%',
    potency: '25mcg',
    form: 'Cholecalciferol',
    suppliers: [{
      name: 'DSM Nutritional',
      cost: '$0.045',
      primary: true,
      certified: true
    }, {
      name: 'BASF',
      cost: '$0.052',
      primary: false,
      certified: true
    }, {
      name: 'Zhejiang Garden',
      cost: '$0.038',
      primary: false,
      certified: false
    }],
    allergens: ['None'],
    certificates: ['USP Verified', 'Third-party tested'],
    specifications: 'Minimum 40,000 IU/g potency, oil suspension'
  }, {
    ingredient: 'Vitamin C (Ascorbic Acid)',
    quantityPerServing: '500mg',
    costPerUnit: '$0.032',
    extendedCost: '$0.96',
    supplier: 'BASF',
    dailyValue: '556%',
    potency: '500mg',
    form: 'L-Ascorbic Acid',
    suppliers: [{
      name: 'BASF',
      cost: '$0.032',
      primary: true,
      certified: true
    }, {
      name: 'DSM Nutritional',
      cost: '$0.035',
      primary: false,
      certified: true
    }],
    allergens: ['None'],
    certificates: ['USP Grade', 'Non-GMO verified'],
    specifications: '99.5% minimum purity, crystalline powder'
  }];
  const packagingComponents = [{
    component: 'HDPE Bottle',
    specification: '60cc White',
    quantity: '1 unit',
    costPerUnit: '$0.120',
    extendedCost: '$0.120',
    supplier: 'Berry Global',
    certifications: ['FDA Approved', 'USP Class VI'],
    specifications: '60cc HDPE, white, pharmaceutical grade'
  }, {
    component: 'Child-Resistant Cap',
    specification: '33mm CRC',
    quantity: '1 unit',
    costPerUnit: '$0.085',
    extendedCost: '$0.085',
    supplier: 'Aptar',
    certifications: ['CPSC Certified', 'FDA Approved'],
    specifications: '33mm CRC with EPE liner, white'
  }, {
    component: 'Desiccant',
    specification: '1g Silica Gel',
    quantity: '1 unit',
    costPerUnit: '$0.015',
    extendedCost: '$0.015',
    supplier: 'Clariant',
    certifications: ['FDA Approved'],
    specifications: '1g silica gel sachet, meets USP requirements'
  }, {
    component: 'Label',
    specification: 'Front & Back',
    quantity: '1 set',
    costPerUnit: '$0.045',
    extendedCost: '$0.045',
    supplier: 'CCL Industries',
    certifications: ['UL Certified'],
    specifications: 'Pressure-sensitive, white BOPP, 4-color process'
  }];
  const totalIngredientsCost = ingredients.reduce((sum, item) => sum + parseFloat(item.extendedCost.replace('$', '')), 0);
  const totalPackagingCost = packagingComponents.reduce((sum, item) => sum + parseFloat(item.extendedCost.replace('$', '')), 0);
  const toggleExpanded = (ingredient: string) => {
    setExpandedIngredient(expandedIngredient === ingredient ? null : ingredient);
  };
  return <div className="space-y-6" data-id="element-23">
      {/* Formulation Ingredients Section */}
      <div className="bg-white rounded-lg border" data-id="element-24">
        <div className="p-6 border-b border-gray-200" data-id="element-25">
          <div data-id="element-26">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-27">
              Formulation Ingredients
            </h2>
            <p className="text-sm text-gray-600 mt-1" data-id="element-28">
              Active and inactive ingredients ordered by quantity
            </p>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-29">
          <table className="w-full" data-id="element-30">
            <thead className="bg-gray-50" data-id="element-31">
              <tr data-id="element-32">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-8" data-id="element-33"></th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-34">
                  Ingredient Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-35">
                  Quantity/Serving
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-36">
                  % Daily Value
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-37">
                  Cost/Unit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-38">
                  Extended Cost
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-39">
                  Supplier
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-40">
              {ingredients.map(item => <Fragment key={item.ingredient} data-id="element-41">
                  <tr className="hover:bg-gray-50 cursor-pointer" onClick={() => toggleExpanded(item.ingredient)} data-id="element-42">
                    <td className="px-6 py-4" data-id="element-43">
                      {expandedIngredient === item.ingredient ? <ChevronDown className="w-4 h-4 text-gray-400" data-id="element-44" /> : <ChevronRight className="w-4 h-4 text-gray-400" data-id="element-45" />}
                    </td>
                    <td className="px-6 py-4" data-id="element-46">
                      <div className="flex items-center" data-id="element-47">
                        <div className="text-sm font-medium text-gray-900" data-id="element-48">
                          {item.ingredient}
                        </div>
                        <div className="flex ml-2" data-id="element-49">
                          {item.certificates.some(cert => cert.includes('USP')) && <Award className="w-4 h-4 text-green-600 ml-1" data-id="element-50" />}
                          {item.allergens.some(allergen => allergen !== 'None') && <AlertTriangle className="w-4 h-4 text-yellow-600 ml-1" data-id="element-51" />}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-52">
                      {item.quantityPerServing}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-53">
                      {item.dailyValue}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-54">
                      {item.costPerUnit}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-55">
                      {item.extendedCost}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-56">
                      {item.supplier}
                    </td>
                  </tr>
                  {expandedIngredient === item.ingredient && <tr data-id="element-57">
                      <td colSpan={7} className="px-6 py-4 bg-gray-50" data-id="element-58">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-59">
                          {/* Specifications */}
                          <div data-id="element-60">
                            <h4 className="font-medium text-gray-900 mb-3" data-id="element-61">
                              Specifications
                            </h4>
                            <div className="space-y-2 text-sm" data-id="element-62">
                              <div className="flex justify-between" data-id="element-63">
                                <span className="text-gray-600" data-id="element-64">Potency:</span>
                                <span className="font-medium" data-id="element-65">
                                  {item.potency}
                                </span>
                              </div>
                              <div className="flex justify-between" data-id="element-66">
                                <span className="text-gray-600" data-id="element-67">Form:</span>
                                <span className="font-medium" data-id="element-68">{item.form}</span>
                              </div>
                              <div className="mt-3" data-id="element-69">
                                <span className="text-gray-600" data-id="element-70">Details:</span>
                                <p className="text-gray-900 mt-1" data-id="element-71">
                                  {item.specifications}
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* Suppliers */}
                          <div data-id="element-72">
                            <h4 className="font-medium text-gray-900 mb-3" data-id="element-73">
                              Available Suppliers
                            </h4>
                            <div className="space-y-3" data-id="element-74">
                              {item.suppliers.map((supplier, index) => <div key={index} className={`p-3 rounded-lg border ${supplier.primary ? 'border-purple-200 bg-purple-50' : 'border-gray-200 bg-white'}`} data-id="element-75">
                                  <div className="flex items-center justify-between mb-2" data-id="element-76">
                                    <div className="flex items-center space-x-2" data-id="element-77">
                                      <Building className="w-4 h-4 text-gray-600" data-id="element-78" />
                                      <span className="font-medium text-gray-900" data-id="element-79">
                                        {supplier.name}
                                      </span>
                                      {supplier.primary && <span className="inline-flex px-2 py-1 rounded text-xs font-medium bg-purple-100 text-purple-800" data-id="element-80">
                                          Primary
                                        </span>}
                                    </div>
                                    <span className="font-semibold text-gray-900" data-id="element-81">
                                      {supplier.cost}
                                    </span>
                                  </div>
                                </div>)}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>}
                </Fragment>)}
            </tbody>
          </table>
        </div>
      </div>
      {/* Packaging Components Section */}
      <div className="bg-white rounded-lg border" data-id="element-82">
        <div className="p-6 border-b border-gray-200" data-id="element-83">
          <div className="flex items-center space-x-2" data-id="element-84">
            <Package className="w-5 h-5 text-gray-600" data-id="element-85" />
            <div data-id="element-86">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-87">
                Packaging Components
              </h2>
              <p className="text-sm text-gray-600 mt-1" data-id="element-88">
                Primary and secondary packaging materials
              </p>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-89">
          <table className="w-full" data-id="element-90">
            <thead className="bg-gray-50" data-id="element-91">
              <tr data-id="element-92">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-93">
                  Component
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-94">
                  Specification
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-95">
                  Quantity
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-96">
                  Cost/Unit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-97">
                  Extended Cost
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-98">
                  Supplier
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-99">
              {packagingComponents.map(item => <tr key={item.component} className="hover:bg-gray-50" data-id="element-100">
                  <td className="px-6 py-4" data-id="element-101">
                    <div className="flex items-center" data-id="element-102">
                      <div className="text-sm font-medium text-gray-900" data-id="element-103">
                        {item.component}
                      </div>
                      {item.certifications.some(cert => cert.includes('FDA')) && <Award className="w-4 h-4 text-green-600 ml-2" data-id="element-104" />}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-105">
                    {item.specification}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-106">
                    {item.quantity}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-107">
                    {item.costPerUnit}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-108">
                    {item.extendedCost}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-109">
                    {item.supplier}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {/* Cost Summary Section */}
      <div className="bg-white rounded-lg border p-6" data-id="element-110">
        <div className="flex items-center space-x-2 mb-4" data-id="element-111">
          <DollarSign className="w-5 h-5 text-gray-600" data-id="element-112" />
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-113">Cost Summary</h2>
        </div>
        <div className="space-y-4" data-id="element-114">
          <div className="flex items-center justify-between text-sm" data-id="element-115">
            <span className="text-gray-600" data-id="element-116">Ingredients Cost:</span>
            <span className="font-semibold text-gray-900" data-id="element-117">
              ${totalIngredientsCost.toFixed(2)}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm" data-id="element-118">
            <span className="text-gray-600" data-id="element-119">Packaging Cost:</span>
            <span className="font-semibold text-gray-900" data-id="element-120">
              ${totalPackagingCost.toFixed(2)}
            </span>
          </div>
          <div className="pt-4 border-t border-gray-200" data-id="element-121">
            <div className="flex items-center justify-between" data-id="element-122">
              <span className="text-base font-medium text-gray-900" data-id="element-123">
                Total BOM Cost:
              </span>
              <span className="text-lg font-bold text-gray-900" data-id="element-124">
                ${(totalIngredientsCost + totalPackagingCost).toFixed(2)}
              </span>
            </div>
            <p className="text-xs text-gray-500 mt-1" data-id="element-125">
              Cost per unit, excluding labor and overhead
            </p>
          </div>
        </div>
      </div>
    </div>;
}